import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useFeatureFlags } from "hooks/useFeatureFlags";

/**
 * Whether the vendor stats dashboard (and its show/hide toggle) render.
 *
 * Two halves:
 *   - a view gate — the dashboard lives on the reworked Manifests surface, so
 *     the tenant needs `manifest-views-v2`.
 *   - a data gate — `waste-epa-correction-discrepancies` gates the correction
 *     data every tile queries, so the dashboard never renders empty.
 *
 * `manifest-views-v2` carries `staffOverride: true`, so `useFeatureFlags`
 * resolves it on for staff and no explicit `isStaff` check is needed here.
 *
 * The dashboard and its toggle both call this so their gates can't drift.
 */
export function useVendorDashboardEnabled(): boolean {
  const { featureFlags } = useFeatureFlags();
  const hasViewFlag = !!featureFlags[FeatureFlagKey.ManifestViewsV2];
  return hasViewFlag && !!featureFlags[FeatureFlagKey.WasteEpaCorrectionDiscrepancies];
}
